import { render, staticRenderFns } from "./form-partial-human-resources.vue?vue&type=template&id=38032c62"
import script from "./form-partial-human-resources.vue?vue&type=script&lang=js"
export * from "./form-partial-human-resources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports